export default "__VITE_PUBLIC_ASSET__8e1caae6__"